import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

export default function DiscoveryCta({
  interest = 'undecided',
  label = 'Book a discovery call',
  className = '',
}) {
  return (
    <Link
      to={`/partner-discovery?interest=${interest}`}
      className={`cta-glow inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#F49558] px-7 py-4 font-bold text-[#101F1F] shadow-cta transition hover:bg-[#F6D541] ${className}`}
    >
      {label}
      <SafeIcon name="ArrowRight" className="h-5 w-5" />
    </Link>
  );
}